import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import {
  useOrganization,
  type ModuleKey,
} from "../organization/OrganizationProvider";

type ModuleRouteProps = {
  moduleKey: ModuleKey;
  children: ReactNode;
};

export function ModuleRoute({ moduleKey, children }: ModuleRouteProps) {
  const {
    selectedOrganization,
    modulesLoading,
    isModuleEnabled,
  } = useOrganization();

  if (modulesLoading) {
    return (
      <div className="page">
        <section className="empty-state">
          <strong>Validando módulo…</strong>
        </section>
      </div>
    );
  }

  if (!selectedOrganization || !isModuleEnabled(moduleKey)) {
    return (
      <div className="page">
        <section className="empty-state">
          <strong>Módulo no disponible.</strong>
          <p>Este módulo no está habilitado para la empresa seleccionada.</p>
          <Link className="compact-button" to="/">
            Volver al inicio
          </Link>
        </section>
      </div>
    );
  }

  return <>{children}</>;
}
